import { ReactNode } from 'react';
import ReactSelect, { GroupBase, OptionsOrGroups, Props as SelectProps } from 'react-select';
import Creatable, { CreatableProps } from 'react-select/creatable';

import { WILLOW_SELECT_STYLES, WILLOW_SELECT_THEME } from './styles';

export type Option = { label: ReactNode | JSX.Element; value: string | number; disabled?: true };

export type Options = OptionsOrGroups<any, GroupBase<any>> | Option[];

/**
 * menuPosition: 'fixed' when inside a modal to allow the menu to spill outside
 * menuShouldBlockScroll: true when paired with menuPosition: 'fixed' to fix the menu not closing when clicking outside
 */
export type ReactSelectOverrides = Pick<SelectProps, 'menuPosition' | 'menuShouldBlockScroll'>;

export function WillowSelect<TOptions extends Options, TIsMulti extends boolean>(
  props: SelectProps<TOptions, TIsMulti>,
) {
  return <ReactSelect styles={WILLOW_SELECT_STYLES} theme={WILLOW_SELECT_THEME} {...props} />;
}

export function WillowCreatableSelect<TOption extends Option, TIsMulti extends boolean>(
  props: CreatableProps<TOption, TIsMulti, GroupBase<TOption>>,
) {
  return <Creatable styles={WILLOW_SELECT_STYLES} theme={WILLOW_SELECT_THEME} {...props} />;
}
